<template>
  <DocumentPreview
    :file="store.resume.file"
    :url="store.resume.fileDataUrl"
  />
</template>

<script setup>
import {useParseResumeStore} from "../stores/ParseResumeStore";
import DocumentPreview from "./DocumentPreview.vue";

const store = useParseResumeStore();
</script>
